import type { JobProfileStructuredDescription, SectionTagDefinition } from '~/shared/data-contract/job-profile';

export const structuredTaskSectionIds = (
    sectionTags: readonly SectionTagDefinition[] | undefined,
): ReadonlySet<string> => new Set((sectionTags ?? []).filter(({ type }) => type === 'TASKS').map(({ id }) => id));

/**
 * The task elements the backend synthesizes into the structured content of TASKS-type template
 * sections, in ref order: one element per task carrying the task title in the translation's
 * language and, for persisted profiles, the taskId to join against the rich `tasks` array.
 */
export const collectStructuredTaskElements = (
    sectionTags: readonly SectionTagDefinition[] | undefined,
    structured: readonly JobProfileStructuredDescription[] | undefined,
): readonly JobProfileStructuredDescription[] => {
    const taskSectionIds = structuredTaskSectionIds(sectionTags);

    return (structured ?? []).filter((item) => item.id !== undefined && taskSectionIds.has(item.id));
};
